module.exports = __webpack_public_path__ + "img/collection-weddingRingsStarrySky.a16e034.webp";